module.exports = __webpack_public_path__ + "img/Matematicas II.373022ec.png";